import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';

/**
 * Direct selector to the fulfillmentNoteDetailPage state domain
 */

const selectFulfillmentNoteDetailPageDomain = (state: ApplicationRootState) => {
  return state ? state.fulfillmentNoteDetailPage : initialState;
};

/**
 * Other specific selectors
 */

/**
 * Default selector used by OrderDetailsPage
 */

const selectFulfillmentNoteDetailPage = () =>
  createSelector(selectFulfillmentNoteDetailPageDomain, (substate) => {
    return substate;
  });

const selectIsOpenModal = () => createSelector(selectFulfillmentNoteDetailPageDomain, (substate) => substate.isOpen);
const selectNote = () => createSelector(selectFulfillmentNoteDetailPageDomain, (substate) => substate.selectedNote);

export default selectFulfillmentNoteDetailPage;
export { selectFulfillmentNoteDetailPageDomain, selectIsOpenModal, selectNote };
